exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal {\n  height: auto; }\n\n.modal-dialog {\n  height: auto;\n  overflow-y: initial !important; }\n\n.modal-content {\n  max-height: 90vh;\n  position: -ms-device-fixed; }\n\n.modal-body {\n  max-height: 75vh;\n  overflow-y: auto; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/common/modal-window.scss
// module id = 1231
// module chunks = 0